// import { Collection } from 'mongodb'
// import ObjectID from 'bson-objectid'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { useContext, useEffect, useState, useRef } from 'react'
import { Breadcrumbs, ListItemButton, Typography } from '@mui/material'

import { Customer, Payment } from '../types'
import NextIcon from '../assets/icons/next-icon.svg'
import { requestAccessToken } from '../api/auth.api'
import { AuthContext, /*DbContext, */ UserContext } from '../contexts'
import { getPaymentReviewedDetailsData } from '../api/app-data.api'
// import { handleDeleteDataByOne, handleGetDataFromTableById } from '../utils/db/common-methods'
import { /*handleGetDataFromAvailableResourceById, handleGetRealmCollectionData, */ normalizePaymentData /*normalizeUnidentifiedCustomerData*/ } from '../utils'
import { PaymentToReviewDetailsTable } from '../components/payment-to-review-details-management/payment-to-review-details-table'

const PaymentReviewedDetailsManagement = () => {
  const navigate = useNavigate()
  const { isAuth } = useContext(AuthContext)
  const { userSession } = useContext(UserContext)
  const currentLoadingDataRef = useRef<boolean>(true)
  const { paymentId, customerCompanyId } = useParams()
  const currentPaymentDetailsRef = useRef<Payment | Partial<Payment>>({})
  // const { customersRealmApp, unidentifiedCustomersRealmApp, paymentsDbEvents, paymentsRealmApp } = useContext(DbContext)
  const { t } = useTranslation(['customer-companies-management', 'customer-company-details-management', 'payments-to-review-management'])

  const [loadingLocalData, setLoadingLocalData] = useState<boolean>(true)
  // const [paymentsCollection, setPaymentsCollection] = useState<Collection | null>(null)
  // const [customersCollection, setCustomersCollection] = useState<Collection | null>(null)
  const [paymentData, setPaymentData] = useState<Payment | Partial<Payment> | null>(null)
  const [paymentCustomerData, setPaymentCustomerData] = useState<Customer | Partial<Customer>>({})
  // const [unidentifiedCustomersCollection, setUnidentifiedCustomersCollection] = useState<Collection | null>(null)

  useEffect(() => {
    if (userSession && userSession.role !== 'super-admin' && userSession.role !== 'super-admin-client') {
      navigate('/404')
      return
    }

    handleGetPaymentReviewedDetails()

    // handleSetPaymentsCollection()
    // handleSetCustomersCollection()
    // handleSetUnidentifiedCustomersCollection()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSession])

  const handleGetPaymentReviewedDetails = async () => {
    let localPaymentReviewedDetailsToSet: any = {}
    const localPaymentReviewedDetails = globalThis.sessionStorage.getItem(`paymentReviewedDetailsData:${paymentId}`)

    if (localPaymentReviewedDetails) {
      localPaymentReviewedDetailsToSet = JSON.parse(localPaymentReviewedDetails)
      handleSetInitialData(localPaymentReviewedDetailsToSet)
    }

    handleGetPaymentReviewedDetailsFromRemote()
  }

  const handleGetPaymentReviewedDetailsFromRemote = async () => {
    try {
      const {
        data: { accessToken }
      } = await requestAccessToken(isAuth?.replaceAll('"', '') ?? '')
      const { data } = await getPaymentReviewedDetailsData(String(paymentId), accessToken)

      handleSetInitialData(data)
      globalThis.sessionStorage.setItem(`paymentReviewedDetailsData:${paymentId}`, JSON.stringify(data))
    } catch (error) {
      console.log('Error handleGetPaymentReviewedDetails > ', error)
    }
  }

  const handleSetInitialData = async (dataToSet: any) => {
    console.log('dataToSet > ', dataToSet)
    const paymentNormalizedData = normalizePaymentData(dataToSet.paymentReviewed) as Payment
    currentPaymentDetailsRef.current = paymentNormalizedData

    setPaymentCustomerData(dataToSet.customerData)
    setPaymentData(paymentNormalizedData)

    if (currentLoadingDataRef.current === true) {
      currentLoadingDataRef.current = false
      setLoadingLocalData(false)
    }
  }

  // useEffect(() => {
  //   if (paymentId) {
  //     const isAllowedToUpdateData = paymentsDbEvents.length === 0 || !paymentData ? true : String(paymentsDbEvents[0].fullDocument._id) === paymentId

  //     if (customersCollection && paymentsCollection && isAllowedToUpdateData) {
  //       if (paymentsDbEvents.length > 0 && paymentsDbEvents[0].operationType === 'delete' && String(paymentsDbEvents[0].documentKey._id) === paymentId) {
  //         handleDeletePaymentFromLocalDB(String(paymentsDbEvents[0].documentKey._id))
  //       }

  //       handleSyncPaymentDetailsDataFromRemoteDB()
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [paymentId, customersCollection, paymentsCollection, paymentsDbEvents])

  // const handleSetPaymentsCollection = async () => {
  //   const paymentsCollectionToSet = await handleGetRealmCollectionData(paymentsRealmApp, 'payments')
  //   setPaymentsCollection(paymentsCollectionToSet)
  // }

  // const handleSetCustomersCollection = async () => {
  //   const customersCollectionToSet = await handleGetRealmCollectionData(customersRealmApp, 'customers')
  //   setCustomersCollection(customersCollectionToSet)
  // }

  // const handleSetUnidentifiedCustomersCollection = async () => {
  //   const unidentifiedCustomersCollectionToSet = await handleGetRealmCollectionData(unidentifiedCustomersRealmApp, 'unidentifiedcustomers')
  //   setUnidentifiedCustomersCollection(unidentifiedCustomersCollectionToSet)
  // }

  // const handleDeletePaymentFromLocalDB = async (documentKey: string) => {
  //   const paymentDataSetted: Array<Payment> = (await handleGetDataFromTableById('payments', String(documentKey))) as Array<Payment>

  //   if (paymentDataSetted.length > 0) {
  //     await handleDeleteDataByOne('payments', documentKey)
  //     navigate('/payments-to-review')
  //   }
  // }

  // const handleSyncPaymentDetailsDataFromRemoteDB = async () => {
  //   const currentPaymentDataDetailsFromRemoteDb = (await paymentsCollection?.aggregate([
  //     {
  //       $match: {
  //         deleted: false,
  //         belongsTo: customerCompanyId,
  //         _id: ObjectID(String(paymentId))
  //       }
  //     },
  //     { $unset: ['deleted', '__v'] }
  //   ])) as unknown as Array<Payment>

  //   if (currentPaymentDataDetailsFromRemoteDb.length === 0) {
  //     navigate('/404')
  //     return
  //   }

  //   const paymentNormalizedData = normalizePaymentData(currentPaymentDataDetailsFromRemoteDb[0] || {})

  //   if (paymentNormalizedData.unidentifiedCustomerId) {
  //     try {
  //       const unidentifiedCustomerDataFromRemoteDb = await unidentifiedCustomersCollection?.findOne({
  //         // @ts-expect-error TS2769
  //         _id: ObjectID(paymentNormalizedData.unidentifiedCustomerId),
  //         deleted: false
  //       })

  //       if (!unidentifiedCustomerDataFromRemoteDb) {
  //         navigate('/payments-to-review', { replace: true })
  //         return
  //       }

  //       currentPaymentDetailsRef.current = paymentNormalizedData
  //       const unidentifiedCustomerData = normalizeUnidentifiedCustomerData(unidentifiedCustomerDataFromRemoteDb)

  //       setPaymentCustomerData(unidentifiedCustomerData)
  //       setPaymentData(paymentNormalizedData)
  //     } catch (error) {
  //       console.log('Error > unidentifiedCustomerDataFromRemoteDb > ', String(error))
  //     }
  //   } else {
  //     const customerData = await handleGetDataFromAvailableResourceById('customers', customersCollection, String(paymentNormalizedData.customerId))
  //     currentPaymentDetailsRef.current = paymentNormalizedData

  //     setPaymentCustomerData(customerData)
  //     setPaymentData(paymentNormalizedData)
  //   }

  //   if (currentLoadingDataRef.current === true) {
  //     currentLoadingDataRef.current = false
  //     setLoadingLocalData(false)
  //   }
  // }

  return (
    <div className="section-container">
      <Breadcrumbs
        separator={
          <img
            src={NextIcon}
            alt="next-icon"
          />
        }
        aria-label="breadcrumb"
      >
        <ListItemButton
          sx={{
            '&.MuiButtonBase-root': {
              padding: '0px'
            },
            '&.MuiButtonBase-root:hover': {
              backgroundColor: 'rgba(0,0,0,0)'
            }
          }}
          onClick={() => navigate('/customer-companies')}
        >
          <Typography
            key="1"
            className="breadcrumb-inactive"
          >
            {t('breadcrumbs.firstLevel', { ns: 'customer-companies-management' })}
          </Typography>
        </ListItemButton>
        <ListItemButton
          sx={{
            '&.MuiButtonBase-root': {
              padding: '0px'
            },
            '&.MuiButtonBase-root:hover': {
              backgroundColor: 'rgba(0,0,0,0)'
            }
          }}
          onClick={() => navigate(`/customer-company-details/${customerCompanyId}`)}
        >
          <Typography
            key="2"
            className="breadcrumb-inactive"
          >
            {t('breadcrumbs.secondLevel', { ns: 'customer-company-details-management' })}
          </Typography>
        </ListItemButton>
        <Typography
          key="3"
          className="breadcrumb-active"
        >
          {t('breadcrumbs.paymentReviewed', { ns: 'customer-company-details-management' })}
        </Typography>
      </Breadcrumbs>
      {loadingLocalData ? (
        <div className="payment-to-review-details-container">
          <div className="payment-to-review-details-title">{t('title')}</div>
          <div className="documents-list-container">
            <div className="documents-list-item-data-container-loader"></div>
            <div className="documents-list-item-data-container-loader"></div>
          </div>
        </div>
      ) : (
        <div className="payment-to-review-details-container">
          <div className="payment-to-review-details-title">{t('title', { ns: 'payments-to-review-management' })}</div>
          <PaymentToReviewDetailsTable
            paymentData={paymentData}
            showBackgroundNoveltiesData
            paymentCustomerData={paymentCustomerData}
            hideReviewButtonInRow={!!customerCompanyId}
          />
        </div>
      )}
    </div>
  )
}

export default PaymentReviewedDetailsManagement
